/**
 * Teacher Gift Customizer
 */

class TeacherGiftCustomizer {
  constructor() {
    this.container = document.querySelector('.teacher-gift-customizer');
    if (!this.container) return;

    this.basePrice = parseInt(this.container.dataset.basePrice || 0);
    this.init();
  }

  init() {
    try {
      this.cacheElements();
      this.attachEventListeners();
      this.updatePriceDisplay();
      this.attachFormValidation();
    } catch (error) {
      console.error('Teacher Gift Customizer Error:', error);
    }
  }

  cacheElements() {
    const find = (selector) => this.container.querySelector(selector);

    this.teacherName = find('.teacher-name');
    this.teacherGrade = find('.teacher-grade');
    this.teacherSubject = find('.teacher-subject');
    this.schoolYear = find('.school-year');
    
    this.totalPriceElement = find('.teacher-gift-customizer__total .teacher-gift-customizer__price-value');
    this.form = this.teacherName ? this.teacherName.closest('form') : null;
    this.globalError = find('.teacher-gift-customizer__global-error');
  }

  attachEventListeners() {
    // No price changes for teacher gifts - just validation
  }

  updatePriceDisplay() {
    if (!this.totalPriceElement) return;
    this.totalPriceElement.textContent = this.formatMoney(this.basePrice);
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  attachFormValidation() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      if (!this.validateForm()) {
        e.preventDefault();
        e.stopPropagation();
        this.showGlobalError('Please fill in all required fields before adding to cart.');
        
        const firstError = this.container.querySelector('.teacher-gift-customizer__error:not(:empty)');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  validateForm() {
    let isValid = true;
    this.clearGlobalError();

    if (this.teacherName && !this.teacherName.value.trim()) {
      this.showError(this.teacherName, 'Teacher name is required');
      isValid = false;
    } else if (this.teacherName) {
      this.clearError(this.teacherName);
    }

    if (this.teacherGrade) {
      const selectedOption = this.teacherGrade.options[this.teacherGrade.selectedIndex];
      if (!selectedOption.value || selectedOption.disabled) {
        this.showError(this.teacherGrade, 'Please select a grade');
        isValid = false;
      } else {
        this.clearError(this.teacherGrade);
      }
    }

    return isValid;
  }

  showError(field, message) {
    const errorElement = document.querySelector(`[data-error-for="${field.id}"]`);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
    field.classList.add('field--error');
  }

  clearError(field) {
    const errorElement = document.querySelector(`[data-error-for="${field.id}"]`);
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
    }
    field.classList.remove('field--error');
  }

  showGlobalError(message) {
    if (this.globalError) {
      const messageElement = this.globalError.querySelector('.error-message');
      if (messageElement) {
        messageElement.textContent = message;
      }
      this.globalError.style.display = 'block';
    }
  }

  clearGlobalError() {
    if (this.globalError) {
      this.globalError.style.display = 'none';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TeacherGiftCustomizer();
  });
} else {
  new TeacherGiftCustomizer();
}
